import * as _ from 'lodash';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { LogService } from './services/log.service';
import { SessionService } from './services/session.service';
import { MessageService } from './services/message.service';
import { SessionStorageService } from './services/session-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // If the last / fragment of the path is any of the following, we are in the common UI
  private commonUiPaths = ['', 'ui', 'mx-access'];

  showLinksOnLogin = false;
  isCommonUi: boolean;
  mxLogoSrc: string;

  @HostListener('window:beforeunload')
  callNotifyLogout() {
    this.session.callNotifyLogout();
    return true;
  }

  constructor(
    private route: Router,
    private log: LogService,
    private session: SessionService,
    private messageService: MessageService,
    private sessionStorage: SessionStorageService
  ) {}

  ngOnInit() {
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        // Only look at last part of url for browser compatibility; IE passes /csp/mxuux/ui/path while others pass /path
        // Also strip query params for comparison
        const lastPath = _.replace(
          _.last(_.split(event['url'], '/')),
          /\?.*/,
          ''
        );
        this.isCommonUi = _.includes(this.commonUiPaths, lastPath);
        
        //If an authorization code is provided, save it off (along with client ID) so that we can bypass user login and use directAuth workflow
        if (lastPath === 'login') {
          const queryParams = new URLSearchParams(window.location.search);
          const authCode = queryParams.get('code');
          const clientId = queryParams.get('state');
          
          if (authCode && clientId) {
            this.log.trace('Authorization code and clientId found:', authCode+' &'+clientId);
            
            this.sessionStorage.setAuthCode(authCode);
            this.sessionStorage.setAuthClient(clientId);
          }
          else {
            this.sessionStorage.setAuthCode('');
            this.sessionStorage.setAuthClient('');
          }
        }

      });

    this.mxLogoSrc = environment.assets.mxLogo;
  }

  onUserAction(event) {
    this.session.registerUserAction();
    // Need to send a message to Access if the user is active in UUX but not in Access
    // (i.e., header or left nav menu)
    this.messageService.postRefreshMessage();
  }
}
